/**
 * Polyfills for missing JavaScript features in older browsers/WebView versions
 * This file is loaded automatically by Angular's build system when configured properly.
 */

// Polyfill for Map.groupBy (ES2024 feature) - not supported in older browsers/WebView
if (!(Map as any).groupBy) {
  (Map as any).groupBy = function <T, K>(
    items: Iterable<T>,
    keySelector: (item: T, index: number) => K,
  ): Map<K, T[]> {
    const map = new Map<K, T[]>();
    let index = 0;

    for (const item of items) {
      const key = keySelector(item, index++);
      const group = map.get(key);

      if (group) {
        group.push(item);
      } else {
        map.set(key, [item]);
      }
    }

    return map;
  };
}

// Polyfill for Array.prototype.toSorted (ES2023 feature) - not supported in older browsers/WebView
if (!Array.prototype.toSorted) {
  Array.prototype.toSorted = function <T>(
    this: T[],
    compareFn?: (a: T, b: T) => number,
  ): T[] {
    return [...this].sort(compareFn);
  };
}

// TypeScript declaration for Map.groupBy and Array.prototype.toSorted
declare global {
  interface MapConstructor {
    groupBy<T, K>(
      items: Iterable<T>,
      keySelector: (item: T, index: number) => K,
    ): Map<K, T[]>;
  }

  interface Array<T> {
    toSorted(compareFn?: (a: T, b: T) => number): T[];
  }
}

// Export to make this file a module (required for declare global)
export {};
